
function ToArrayFilter() {
    return function(obj) {
        return Object.keys(obj);
    };
}

export default ToArrayFilter;
